import * as yup from 'yup';
import { isAppointmentTypeVisible } from '../../helpers';
import { buildDefaultMessages, commonDefaults } from '../shared/campaignDefaults';
import { hasBaseErrors, hasInvalidReminderDelay } from '../shared/primaryActionChecks';
import { commonSchemaShape, withMessageOrderTest } from '../shared/validationSchema';
import { withoutMessageTime } from '../shared/payloadMessages';
import { CampaignTypeSpec } from '../policy';
import { policyIssue } from '../issues';
import { negated, standardFields } from './shared';

export const reminderSpec: CampaignTypeSpec = {
  externalType: 'appointment',
  scheduleKind: 'reminder',
  supportsMessageAppointments: false,
  defaultScheduledType: 'delay',

  fields: config => [
    ...(isAppointmentTypeVisible(config) ? (['appointmentType'] as const) : []),
    ...standardFields(config),
  ],

  defaults: config => ({
    ...commonDefaults(config),
    scheduledMessages: buildDefaultMessages(config, { scheduledType: 'contact_added' })
      .map(message => ({ ...message, attachCalendar: true })),
    appointmentTypeId: '',
  }),

  fromCampaign: (base, campaign) => ({
    ...base,
    appointmentTypeId: campaign.appointmentType?.id ?? '',
  }),

  issues: (values, config) => policyIssue(
    hasBaseErrors(values, config)
    || !values.appointmentTypeId
    || hasInvalidReminderDelay(values),
    'reminder-primary-blocked',
  ),

  keepsEmptyMessage: () => true,

  payload: ({ base, values }) => ({
    ...base,
    scheduledMessages: withoutMessageTime(base.scheduledMessages.map((message, index) => ({
      ...message,
      attachCalendar: !!values.scheduledMessages[index]?.attachCalendar,
      delay: negated(message.delay),
    }))),
    ...(values.appointmentTypeId ? { appointmentTypeId: values.appointmentTypeId } : {}),
  }),

  schema: config => withMessageOrderTest(yup.object({
    ...commonSchemaShape(config, { messages: true }),
    appointmentTypeId: yup
      .string()
      .required('Appointment type is required')
      .min(1, 'Appointment type is required'),
  })),
};
